import { TiModal } from "@ti/ui-mobile";
import { useNavigate } from "react-router";
import { Auth } from "@/utils/authUtils";
import { useT } from "@/utils/intlUtils";
import { getIsOversea } from "@/utils/environmentUtils";
import copy from "copy-to-clipboard";
import telIcon from "@/assets/address/tel.png";
import emailIcon from "@/assets/address/email.png";
import editIcon from "@/assets/address/edit.png";
import delIcon from "@/assets/address/del.png";
import copyIcon from "@/assets/address/copy.png";
import arrow from "@/assets/address/arrow.png";

import {
  ListItemContainer,
  ContactInformation,
  AddressInformation,
  ActionContainer,
  More,
} from "./styles";
import { Address } from "@/services/system/type";
import { deleteAddress } from "@/services/system";
import { Toast } from "antd-mobile";
import MoreInfo from "./MoreInfo";

const isOversea = getIsOversea();

type AddressItemProps = {
  record: Address;
  country: Map<string, any>;
  onRefresh?: () => void;
  form?: "select";
};
export default (props: AddressItemProps) => {
  const navigate = useNavigate();
  const { record, country, onRefresh, form } = props;
  const { addressCfgClearanceDto } = record;
  const t = useT();
  const control = TiModal.useControl();
  const control1 = TiModal.useControl();

  const countryName = country?.get(record?.countryId)?.text;

  const contactNumber = !record?.contactNumber
    ? "-"
    : `${record?.contactNumberPrefix} ${record?.contactNumber}`;

  const clearanceContactNumber = !addressCfgClearanceDto?.contactNumber
    ? ""
    : `${addressCfgClearanceDto?.contactNumberPrefix} ${addressCfgClearanceDto?.contactNumber}`;

  const cityNames =
    [record?.provinceName, record?.cityName, record?.areaName]
      .filter(Boolean)
      .join("-") || "";

  const getCopyData = () => {
    const data = [
      {
        label: t("收件人"),
        value: record?.contactPerson,
      },
      {
        label: t("收货抬头"),
        value: record?.invoiceTitle,
        hideInCopy: !isOversea,
      },
      {
        label: t("税号"),
        value: record?.taxId,
        hideInCopy: !isOversea,
      },
      {
        label: t("收货地区"),
        value: `${countryName} ${cityNames}`,
      },
      {
        label: t("详细地址"),
        value: record?.address,
      },
      {
        label: t("邮编"),
        value: record?.postCode,
      },
      {
        label: t("联系电话"),
        value: contactNumber,
      },
      {
        label: t("联系邮箱"),
        value: record?.email,
      },
      {
        label: t("清关公司"),
        value: addressCfgClearanceDto?.clearanceCompany,
        hideInCopy: !isOversea,
      },
      {
        label: t("清关地址"),
        value: addressCfgClearanceDto?.clearanceAddress,
        hideInCopy: !isOversea,
      },
      {
        label: t("联系人"),
        value: addressCfgClearanceDto?.contactPerson,
        hideInCopy: !isOversea,
      },
      {
        label: t("联系电话"),
        value: clearanceContactNumber,
        hideInCopy: !isOversea,
      },
      {
        label: t("联系邮箱"),
        value: addressCfgClearanceDto?.email,
        hideInCopy: !isOversea,
      },
      {
        label: t("邮编"),
        value: addressCfgClearanceDto?.postCode,
        hideInCopy: !isOversea,
      },
      {
        label: t("税号"),
        value: addressCfgClearanceDto?.taxId,
        hideInCopy: !isOversea,
      },
      {
        label: t("EORI号"),
        value: addressCfgClearanceDto?.economicNumber,
        hideInCopy: !isOversea,
      },
    ];

    let string = "";

    const list = data.filter((i) => !i.hideInCopy);

    list.forEach(({ label, value }) => {
      string += `${label}: ${value || "-"} \n`;
    });
    return string;
  };

  const onCopy = () => {
    const res = copy(getCopyData());
    if (res) {
      Toast.show({
        content: t("成功复制到剪贴板！"),
      });
    }
  };

  const onConfirm = async () => {
    return deleteAddress(record?.id).then(onRefresh);
  };

  return (
    <>
      <ListItemContainer>
        <span className="title">{record?.contactPerson}</span>
        <ContactInformation>
          <img src={telIcon} alt="" />
          <span>{contactNumber}</span>
        </ContactInformation>
        <ContactInformation>
          <img src={emailIcon} alt="" />
          <span>{record?.email || "-"}</span>
        </ContactInformation>
        {isOversea && (
          <AddressInformation style={{ paddingRight: 48 }}>
            <span className="ellipsis-multiline">
              {t("收货抬头")}：{record?.invoiceTitle || "-"}
            </span>
          </AddressInformation>
        )}
        <AddressInformation>
          <span className="ellipsis-multiline">
            {t("收货地区")}：{countryName} {cityNames}
          </span>
        </AddressInformation>
        <AddressInformation>
          <span className="ellipsis-multiline">
            {t("收货地址")}： {record?.address}
          </span>
        </AddressInformation>

        {isOversea && (
          <More
            onClick={(e) => {
              control1.onOpen();
              e?.stopPropagation();
            }}
          >
            <span>{t("更多")}</span>
            <img src={arrow} alt="" className="arrow" />
          </More>
        )}

        {form !== "select" && (
          <ActionContainer>
            <Auth authKey="OAM_062502">
              <img
                src={editIcon}
                alt=""
                onClick={() => {
                  navigate(`/address/edit`, {
                    state: {
                      ...record,
                    },
                  });
                }}
              />
            </Auth>
            <Auth authKey="OAM_062503">
              <img src={delIcon} alt="" onClick={() => control.onOpen()} />
            </Auth>
            <img src={copyIcon} alt="" onClick={onCopy} />
          </ActionContainer>
        )}

        <TiModal.Center {...control} title={t("提示")} onConfirm={onConfirm}>
          <p>{t("确认删除?")}</p>
        </TiModal.Center>
      </ListItemContainer>
      <MoreInfo
        cityNames={cityNames}
        countryName={countryName}
        contactNumber={contactNumber}
        clearanceContactNumber={clearanceContactNumber}
        record={record}
        control={control1}
      />
    </>
  );
};
